import {Component, Inject, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MxButtonModel, MxNotificationService} from 'mx-core';
import {DOCUMENT} from '@angular/common';
import {PrlAuthenticationService} from '../../../../shared/services/prl-authentication.service';
import {PrlLanguageService} from '../../../prl-language/services/prl-language.service';
import {PrlApplicationPropertiesDataService} from "../../../../shared/services/prl-application-properties.service";
import {MatDialog} from "@angular/material/dialog";
import {
    MxForgotPasswordComponent
} from "../../../../../../../mx-core/src/lib/modules/mx-authentication/mx-forgot-password/mx-forgot-password.component";
import {ActivatedRoute} from '@angular/router';
import {PrlAffiliatesDataService} from '../../services/affiliate/prl-affiliates-data.service';

@Component({
    selector: 'prl-login-page',
    templateUrl: './prl-login-page.component.html',
    standalone: false,
    styleUrls: ['./prl-login-page.component.scss']
})
export class PrlLoginPageComponent implements OnInit {
    form: FormGroup = new FormGroup({
        username: new FormControl('', Validators.required),
        password: new FormControl('', Validators.required),
        'remember-me': new FormControl('')
    });
    isRegistrationDisabled: boolean = true;
    loginButton: MxButtonModel;

    @Input() error: string | null;

    constructor(
        private readonly applicationPropertiesService: PrlApplicationPropertiesDataService,
        private readonly affiliatesDataService: PrlAffiliatesDataService,
        private readonly authService: PrlAuthenticationService,
        private readonly dialogRef: MatDialog,
        private readonly languageService: PrlLanguageService,
        private readonly notificationService: MxNotificationService,
        private readonly route: ActivatedRoute,
        @Inject(DOCUMENT) private readonly document: Document) {
    }

    ngOnInit(): void {

        this.route.queryParams.subscribe(params => {

            const username = params['username'];
            const hash = params['hash'];

            if (username && hash) {
                this.affiliatesDataService.activate(username, hash).subscribe({
                    next: (waitForApproval) => {
                        if (waitForApproval) {
                            this.notificationService.showMessageDialog('label.login.account.activated.title',
                                'label.login.account.activated.message',
                                'info');
                        } else {
                            this.notificationService.showSuccess('label.login.account.activated.title');
                        }
                    },
                    error: (err) => {
                        this.notificationService.showFailure(err.error.detail);
                    }
                });

            }
        });

        this.loginButton = {
            label: () => this.getLabel('label.login'),
            permission: 'all',
            tooltip: () => this.getLabel('label.login'),
            className: 'mxs-button--primary',
            disabled: () => this.form.invalid,
            clickHandler: this.login
        };
        this.applicationPropertiesService.isRegistrationDisabled()
            .subscribe(disabled => this.isRegistrationDisabled = disabled);
        this.checkWarning();
    }

    login = () => {
        if (this.form.valid) {
            this.authService.authenticate(this.form.value);
        }
    };

    getLabel = (label: string): string => {
        return this.languageService.getLabel(label);
    };

    showResetPassword = ()=> {
        this.dialogRef.open(
            MxForgotPasswordComponent, {
                panelClass: 'mx-dialog-panel-class',
                width: '250px',
                data: {
                    showOld: true
                }
            });
    };

    private checkWarning(): void {
        let warning = localStorage.getItem('Warning');
        if (warning) {
            this.notificationService.showFailure(warning);
            localStorage.removeItem('Warning');
        }
    }
}

